// Filename - ./components/Navbar.js

import { FaBars } from "react-icons/fa";
import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
	background-color: #FFFFFF;
    width: 100%;
    margin-bottom: 50px;
	padding-left: 25px;
`;

export const NavLink = styled(Link)`
	float: left;
    color: #033ad9;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    font-size: 24px;
    border: 1px solid #808080a9;
    min-width: 100px;
	&.active {
        background-color: #033ad9;
		color: #ffffff;
	}
    @media screen and (max-width: 768px) {
        float: none;
        width: 100%;
    }
    &:hover {
        background-color: #808080;
        color: #033ad9;
    }
`;

export const Bars = styled(FaBars)`
	display: none;
	color: #808080a9;
	@media screen and (max-width: 768px) {
		display: block;
		position: absolute;
		top: 0;
		right: 0;
		transform: translate(-100%, 75%);
		font-size: 1.8rem;
		cursor: pointer;
	}
`;

export const NavMenu = styled.div`
	display: flex;
	align-items: center;
	margin-right: -24px;
	/* Second Nav */
	/* margin-right: 24px; */
	/* Third Nav */
	/* width: 100vw;
white-space: nowrap; */
	@media screen and (max-width: 768px) {
		flex-direction: column;
		width: 100%;
		background-color: #ffffff;
	}
`;
